module.exports = __webpack_public_path__ + "media/LandingPageAssets/ChatImage3-daefa368.png";